var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from 'react';
import { variantStyleMapping } from '../styles';
import { fontStyles, fontWeights } from "../../../tokens/typography";
import { colors } from "../../../tokens/color";
import { getResponsiveStyleObject } from "../../../shared/utils/responsive/responsive";
function TextComponent(props, ref) {
    const { variant = 'body1', weight, color, italic, underline, component, align, children } = props, other = __rest(props, ["variant", "weight", "color", "italic", "underline", "component", "align", "children"]);
    const Component = component || 'p';
    return (_jsx(Component, Object.assign({ ref: ref, css: [
            getResponsiveStyleObject(variant, (variant) => variantStyleMapping[variant]),
            getResponsiveStyleObject(color, (color) => ({ color: colors.text[color] })),
            getResponsiveStyleObject(weight, (weight) => ({ fontWeight: fontWeights[weight] })),
            getResponsiveStyleObject(align, (align) => ({ textAlign: align })),
            {
                fontStyle: italic ? fontStyles.italic : undefined,
                textDecoration: underline ? 'underline' : undefined,
            },
        ] }, other, { children: children })));
}
/**
 * A component used to render text and paragraphs
 *
 * @example
 *<Text variant='body1'>A Text</Text>
 *
 */
export const Text = React.forwardRef(TextComponent);
